module.exports = __webpack_public_path__ + "/img/SOT23-Labeled-PB4jay.svg";